import { AfterViewInit, Component, ElementRef, Input, OnDestroy, OnInit, QueryList, ViewChildren } from '@angular/core';
import { IconType } from '@shared/utils/icons';
import { NavbarMenuItem } from '@shared/utils/menu-items';
import MetisMenu from 'metismenujs';
import { IMMOptions } from 'metismenujs/dist/types/interface';
import { NavbarItemComponent } from '../navbar-item/navbar-item.component';

@Component({
  selector: 'shared-ui-navbars-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.css'],
  standalone: false,
})
export class NavbarComponent implements OnInit, AfterViewInit, OnDestroy {
  @ViewChildren(NavbarItemComponent) navbarItems?: QueryList<NavbarItemComponent>;
  @Input() items: NavbarMenuItem[] | null = new Array<NavbarMenuItem>();

  public IconType = IconType;
  public currentActiveElement: null | NavbarMenuItem = null;

  private metisMenu: MetisMenu | undefined;

  constructor(private elem: ElementRef) {}

  ngOnInit(): void {}

  ngAfterViewInit(): void {
    const mmOpts: IMMOptions = {
      toggle: false,
      parentTrigger: 'li',
      subMenu: 'ul',
      triggerElement: 'a',
    };

    this.metisMenu = new MetisMenu(this.elem.nativeElement.querySelector('#side-menu'), mmOpts);
  }

  ngOnDestroy(): void {
    this.metisMenu?.dispose();
  }

  onClick(item: NavbarMenuItem): void {
    this.currentActiveElement = item;
  }

  isActive(item: NavbarMenuItem): boolean {
    if (item === this.currentActiveElement) {
      return true;
    }

    return false;
  }

  setActiveMenuItem(): void {
    let activeRoute = localStorage.getItem('activeRoute');
    const queryParam = activeRoute?.split('?')[1];
    if (queryParam) {
      activeRoute = activeRoute?.split('?')[0] ?? null;
    }
    let index = -1;

    if (activeRoute === '/') {
      this.currentActiveElement = null;

      return;
    }

    if (this.items && activeRoute) {
      for (let i = 0; i < this.items?.length; i++) {
        const currentItem = this.items[i];
        let childMatch = false;

        if (currentItem.items) {
          childMatch = this.hasChildMatch(currentItem.items, activeRoute);
        }

        if ((childMatch || currentItem.routerLink === activeRoute) && this.navbarItems) {
          if (queryParam) {
            if (currentItem.queryParams === undefined && currentItem.items?.every((child) => child.queryParams === undefined)) {
              continue;
            }
          }

          this.navbarItems['_results'][i].visibleChildElements();
          this.currentActiveElement = currentItem;
          index = i;
          break;
        }
      }

      if (index === -1) {
        this.currentActiveElement = null;
      }
    }
  }

  private hasChildMatch(itemsArray: NavbarMenuItem[], route: string): boolean {
    return itemsArray.some((x) => x.routerLink === route);
  }
}
